export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '[{"name":"请求管理","value":53},{"name":"变更管理","value":23},{"name":"事件管理","value":13},{"name":"问题管理","value":21}]',
    },
    attribute:{
        legendX:20,legendY:5,legendWidth:10,legendHeight:5,itemGap:5,legendSize:12,color:['#0182FF','#50A7FC','#04DCFD','#05FFA1'],hartColor:['#1e3ea1','#091648'],
        legendColor: '',
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }] 
    },
}